"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqr6020DocumentDefinition = exports.sqr601DocumentDefinition = void 0;
var sqr601_1 = require("./sqr601");
Object.defineProperty(exports, "sqr601DocumentDefinition", { enumerable: true, get: function () { return sqr601_1.sqr601DocumentDefinition; } });
var sqr6020_1 = require("./sqr6020");
Object.defineProperty(exports, "sqr6020DocumentDefinition", { enumerable: true, get: function () { return sqr6020_1.sqr6020DocumentDefinition; } });
//# sourceMappingURL=index.js.map